var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.848,
    height: 41.229,
    viewBox: "0 0 27.848 41.229",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3673",
    "data-name": "Group 3673",
    transform: "translate(1977 -1104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_742",
    "data-name": "Group 742",
    transform: "translate(-2188.074 889.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    transform: "translate(211.074 214.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_741",
    "data-name": "Group 741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pin-2",
    "data-name": "Pin",
    d: "M14.071,0h-.162A13.978,13.978,0,0,0,0,13.909,16.7,16.7,0,0,0,2.106,21.3c.825,1.684,11.8,19.929,11.8,19.929s10.8-17.9,11.8-19.874a16.383,16.383,0,0,0,2.142-7.423A13.927,13.927,0,0,0,14.071,0m-.144,20.88h-.018a6.953,6.953,0,0,1,0-13.907h.018a6.953,6.953,0,0,1,0,13.907",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Circle",
    d: "M38.62,29.635a8.985,8.985,0,1,1-8.985-8.985,8.985,8.985,0,0,1,8.985,8.985",
    transform: "translate(-15.709 -15.707)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    transform: "translate(-1972 1109)",
    fill: "red",
    stroke: "red",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 8.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "DQ",
    transform: "translate(-1963 1121)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Gotham-Book, Gotham"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -7.344,
    y: 0
  }, "DQ")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDqIcon);
export default __webpack_public_path__ + "static/media/DQIcon.82dff6970fae57e4d1bce044249ae6ed.svg";
export { ForwardRef as ReactComponent };